import { translateText } from 'utils/i18n';
import { I18N_PLATFORM_COMMON_WORD_PATH } from './i18n';

export const TIME_MEASUREMENTS_LABELS = {
  ANNUAL: translateText(`${I18N_PLATFORM_COMMON_WORD_PATH}.annual`),
  MONTHLY: translateText(`${I18N_PLATFORM_COMMON_WORD_PATH}.monthly`),
};
